<template>
  <div>
    <mdb-card class="card-image image">
      <div class="text-white text-center rgba-stylish-strong py-0 px-4">
        <div class="py-5">
          <h2 class="h2 orange-text"><mdb-icon icon="users-cog" />ICT Training</h2>
        </div>
      </div>
    </mdb-card>
    <div>
      <mdb-container>
        <mdb-row class="my-5">
          <mdb-col lg="4">
            <div>
              <img src="@/assets/ICTtraining.jpeg" alt="" height="250px" width="341px" class="margin">
            </div>
          </mdb-col>
          <mdb-col class="mx-5">
            <h2>ICT Fundamentals Training</h2>
            <p>
              The IT fundamentals course sharpens our clients’ ability on concept of ICT using computer and managing files as well as using the web and communication technologies. Upon successful completion of this course the candidates have to pass tests in the following areas:
              <ul>
                <li>Concepts of IT</li>
                <li>Using Computer</li>
                <li>Managing Files</li>
                <li>Information and Communication</li>
              </ul>
            </p>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-5">
          <mdb-col class="mx-5">
            <h2>SPSS Training</h2>
            <p>
              SPSS, which stands for statistical package for the social sciences, is an application that can aid in quantitative data handling. Before SPSS, researchers had to run statistical tests on data sets by hand. However, SPSS automates this process. SPSS has all of the most widely used statistical tests built-in to the software. Therefore, you won't have to do any mathematical equations by hand. Once you run a statistical test, all associated outputs are displayed in the data output file.
            </p>
          </mdb-col>
          <mdb-col lg="4">
            <div>
              <img src="@/assets/spss.png" alt="" height="250px" width="341px" class="margin">
            </div>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-5">
          <mdb-col lg="4">
            <div>
              <img src="@/assets/networking.jpeg" alt="" height="250px" width="341px" class="margin">
            </div>
          </mdb-col>
          <mdb-col class="mx-5">
            <h2>Networking</h2>
            <p>
              Brief history of cellular wireless telephony, network architectures, Radio technologies, available services and various interfaces will be presented. Topics will include GSM, GPRS, EDGE, UMTS, HSPDA, HSPA, LTE, LTE-A. The specification, strength and weaknesses of each of these technologies will be highlighted, their architecture, call flows and differences indicated. Introduction to modulation schemes used in cellular communication including TDMA, FDMA, TDD, FDD, OFDM, CDMA. Learn the definition of cell in regard to cellular communication.
            </p>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-5">
          <mdb-col class="mx-5">
            <h2>E-learning</h2>
            <p>
              Hypertech also trains on modern instructional methods such as e-Learning Pedagogy. This course equips teachers with modern instructional skills that would enable them teach courses offered online. This course is especially useful for college lecturers, and university lecturers as well as organizations that would wish to offer online courses.
            </p>
          </mdb-col>
          <mdb-col lg="4" >
            <div>
              <img src="@/assets/e-learning.jpeg" alt="E-learning" height="250px" width="341px" class="margin">
            </div>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-5">
          <mdb-col lg="4" >
            <div>
              <img src="@/assets/fiberCable.jpg" alt="Fiber optics" height="250px" width="341px" class="margin">
            </div>
          </mdb-col>
          <mdb-col class="mx-5">
            <h2>Fiber optics</h2>
            <p>
              Fundamentals of optical fiber communication system will be introduced. Topics for this training will include; Introduction & principles of fiber optics, fiber classification, cable types, fiber design and systems, installation, fiber splicing, connectors and Termination, fiber testing, Fiber standards, enclosures and panels, test equipments; restoration and maintenance; System design and component issues, application, Fiber optic safety.
            </p>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-5">
          <mdb-col class="mx-5">
            <h2>Office tools</h2>
            <p>
              The office tools qualification lets you highlight your field of expertise. Now you can distinguish yourself as an IT professional with the current skills and proven job-role capabilities to work effectively with a comprehensive set of Microsoft office tools which include:
              <ul>
                <li>Word-processing</li>
                <li>Spreadsheets</li>
                <li>Databases</li>
                <li>Presentation Tools</li>
              </ul>
            </p>
          </mdb-col>
          <mdb-col lg="4" >
            <div>
              <img src="@/assets/officetools.png" alt="Office tools" height="250px" width="341px" class="margin">
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbCol from 'mdbvue/lib/components/mdbCol'
import mdbRow from 'mdbvue/lib/components/mdbRow'

export default {
  name: 'IctTraining',
  components: {
    mdbCard,
    mdbIcon,
    mdbContainer,
    mdbCol,
    mdbRow
  }
}
</script>

<style scoped>
.image {
  background: url("~@/assets/ICTtraining.jpeg");
}
</style>
